module.exports = __webpack_public_path__ + "img/20190831135242360截图20190831123733016.6c38e66b.jpg";